import { withAuthenticationRequired } from '@auth0/auth0-react';
import LoadingFallback from '../common/LoadingFallback';

// eslint-disable-next-line react/prop-types
function ProtectedRoute({ component }) {
  const Component = withAuthenticationRequired(component, {
    // eslint-disable-next-line react/no-unstable-nested-components,react/react-in-jsx-scope
    onRedirecting: () => (<LoadingFallback />),
  });

  // eslint-disable-next-line react/react-in-jsx-scope
  return <Component />;
}

export default ProtectedRoute;
